// How long the object URL outlives the click. Revoking it in the same tick can cancel the download
// before it starts (seen in Safari).
export const OBJECT_URL_REVOKE_DELAY_MS = 100;

/**
 * Saves CSV text as a file. Uses a Blob URL rather than a data: URI, so a "#" in the content (a
 * "Class #" header, a vendor name) can't cut the file off as a URL fragment.
 */
export function downloadCsv(csv: string, fileName: string): void {
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), OBJECT_URL_REVOKE_DELAY_MS);
}
